import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { listCoProductions } from 'store/Orbita/Product/actions';
import { ruleRunner, run } from 'validations/ruleRunner';
import { isEmail, required } from 'validations/rules';

import styles from '../../styles/';
import ProductTable from '../ProductTable';
import QuickView from './components/Quickview';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

const fieldValidations = {
  emailRecruit: ruleRunner('emailRecruit', 'e-mail', required, isEmail),
};

interface IProps extends DispatchProp<any>, RouteComponentProps<any> {
  coproductions: any;
  classes: any;
  search: string;
  history: any;
  pagination: any;
  user: any;
}

interface IStates {
  actionMenu: any;
  productActive: any;
  modalRecruit: boolean;
  validationErrors: object;
  emailRecruit: string;
  modalCancel: boolean;
  activeQuickView: boolean;
  dataProduct: any;
}

class CoProductions extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      actionMenu: false,
      productActive: null,

      modalRecruit: false,

      emailRecruit: '',
      validationErrors: {},

      modalCancel: false,
      activeQuickView: false,
      dataProduct: null,
    };
  }

  onChangeRowsPerPage = (per_page: number) => {
    this.loadCoProductions({ ...this.props.pagination, ...{ current_page: 1, per_page } }, this.props.search);
  };

  onChangePage = (page: number) => {
    this.loadCoProductions({ ...this.props.pagination, ...{ current_page: page } }, this.props.search);
  };

  loadCoProductions = (pagination: any, title: string) => {
    (async () => {
      try {
        await this.props.dispatch(listCoProductions(pagination, title));
      } catch (error) {
        toast.error(error);
      }
    })();
  };

  handleClickOpenMenuActions = (event: any, product: any) => {
    this.setState({ actionMenu: event.currentTarget, productActive: product });
  };

  handleCloseOpenMenuActions = () => {
    this.setState({ actionMenu: null, productActive: null });
  };

  handleClickShare = () => {
    let { productActive } = this.state;
    let { history } = this.props;

    history.push(`/producer/campaigns/${productActive.product_id}`);
  };

  toggleModalRecruit = () => {
    this.setState({
      modalRecruit: !this.state.modalRecruit,
    });
  };

  handleChangeField = (name: string) => (event: any) => {
    let newState = this.state;
    newState[name] = event.target.value;

    this.setState(newState, () => this.onValidation(name));
  };

  errorFor = (field: any) => this.state.validationErrors[field] || '';

  isValid = (field: any) => (this.state.validationErrors[field] ? true : false);

  onValidation = (field: string) => {
    let validationErrors = this.state.validationErrors;
    let obj = run(this.state, [fieldValidations[field]]);

    validationErrors[field] = obj[field];

    for (let prop in validationErrors) {
      if (!validationErrors[prop]) {
        delete validationErrors[prop];
      }
    }

    this.setState({
      validationErrors,
    });
  };

  toggleModalCancel = () => {
    this.setState({
      modalCancel: !this.state.modalCancel,
    });
  };

  onClickOptions(product: any) {
    this.setState({
      activeQuickView: true,
      dataProduct: product,
    });
  }

  componentDidMount() {
    this.loadCoProductions({ current_page: 1, per_page: 10 }, this.props.search);
  }

  render() {
    const { coproductions, pagination } = this.props;

    return (
      <>
        <ProductTable
          products={coproductions.data}
          order=''
          listProductsChildren={coproductions}
          onClickOptions={(product: any) => this.onClickOptions(product)}
          coproduction={true}
          isLoading={coproductions?.isFetching}
          pagination={{
            current_page: pagination?.current_page ?? 1,
            per_page: pagination?.per_page ?? 10,
            total: pagination?.total_items,
            optionsPerPage: pagination?.optionsPerPage ?? '10,20,30,40',
            onChangePage: this.onChangePage,
            onChangePerPage: this.onChangeRowsPerPage,
          }}
        />

        <QuickView
          active={this.state.activeQuickView}
          changeActive={() => {
            this.setState({ activeQuickView: !this.state.activeQuickView });
          }}
          productData={this.state.dataProduct}
        />
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    coproductions: state.orbita.Product.listCoProductions,
    pagination: state.orbita.Product.listCoProductions.pagination,
  };
}

export default withRouter(connect(mapStateToProps)(styles(CoProductions)));
